import React from 'react'
import PropTypes from 'prop-types'
import './FullScreenButton.scss'

const FullScreenButton = ({toggleFullScreen, isFullscreen}) => {
  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      toggleFullScreen()
    }
  }

  return (
    <div styleName="button-container" data-bi-target="preview-fullscreen-button" data-bi-is-fullscreen={isFullscreen}>
      <div
        data-id="fullscreen-button"
        styleName="fullscreen-button"
        onClick={toggleFullScreen}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        role="button"
        aria-label="Full screen"
      />
    </div>
  )
}

FullScreenButton.propTypes = {
  toggleFullScreen: PropTypes.func.isRequired
}

export default FullScreenButton
